"use strict";

angular.module("customer")
.controller("InventoryReportController", function(
    $scope, FlashBag, UserService, InventoryReportService, InventoryReportPrintButtonService, UserCustomerService,
    INVENTORY_HOLDER
) {
    $scope.inventoryData = null;
    $scope.INVENTORY_HOLDER = INVENTORY_HOLDER;
    $scope.vendorInventoryHolder = $scope.INVENTORY_HOLDER.NONE;
    $scope.defaultInventoryReportPrintFormat = InventoryReportPrintButtonService.PDF_RECEIPT_FORMAT;

    UserCustomerService.release().then(function onSuccess(user) {
        if (user && !!user.global_dedicated_vendor_id) {
            $scope.globalDedicatedVendorId = user.global_dedicated_vendor_id;
            $scope.vendorInventoryHolder = user.dedicated_user_vendor.inventory_holder;

            if ($scope.vendorInventoryHolder === $scope.INVENTORY_HOLDER.CATALOG_ENTRY) {
                fetchAvailableCatalogs();
            } else if($scope.vendorInventoryHolder === $scope.INVENTORY_HOLDER.PRODUCT) {
                InventoryReportService.queryProductInventory().$promise.then(
                    function onSuccess(data) {
                        $scope.inventoryData = data;
                    },
                    function onError(response) {
                        FlashBag.apiError(response);
                    }
                );
            }
        }
    });

    this.fetchCatalogInventoryReport = function(catalogId) {
        if (!catalogId) {
            $scope.inventoryData = null;
            return;
        }

        InventoryReportService.queryCatalogInventory(catalogId).$promise.then(
            function onSuccess(data) {
                $scope.inventoryData = data;
            },
            function onError(response) {
                FlashBag.apiError(response);
            }
        );
    };

    function fetchAvailableCatalogs() {
        InventoryReportService.queryAvailableCatalogs().$promise.then(
            function onSuccess(catalogs) {
                $scope.catalogs = catalogs;
            },
            function onError(response) {
                FlashBag.apiError(response);
            }
        );
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/inventory-report/inventory-report.controller.js
// module id = 950
// module chunks = 0